import { BASE_URL } from "../../../Constant";

export const API_ADD_TIMING : string = BASE_URL + '/api/timing';
export const API_LOAD_BY_BUSINESS_ID : string = BASE_URL + '/api/timing/businessId';
export const API_UPDATE_TIMING : string = BASE_URL + '/api/timing';
